import { getTranslate } from 'react-localize-redux';
import { connect } from 'react-redux';

import { cookieSelectors } from '../../../../../weborder/selectors';
import { PrivacyTerms } from './PrivacyTerms';

export type StateProps = {
  hasGdprCookieFeatureFlag: boolean;
  translate: any;
};

const mapStateToProps = (state): StateProps => ({
  hasGdprCookieFeatureFlag: cookieSelectors.hasGdprCookieFeatureFlag(state),
  translate: getTranslate(state.locale),
});

export default connect(mapStateToProps)(PrivacyTerms);
